import { render } from "./TraineeLogbook.vue?vue&type=template&id=98093e7a&scoped=true"
import script from "./TraineeLogbook.vue?vue&type=script&lang=js"
export * from "./TraineeLogbook.vue?vue&type=script&lang=js"

import "./TraineeLogbook.vue?vue&type=style&index=0&id=98093e7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98093e7a"]])

export default __exports__